//date show like 15-05-2022
export const dateFormat = 'd-m-yy';
